var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var getSnackbarStyles = function (_a) {
    var backrs = _a.backrs, typography = _a.typography;
    return ({
        '& .MuiSnackbarContent-root': {
            backgroundColor: backrs.colors['Colors/Base/Black'],
            borderRadius: backrs.radius['radius-md'],
            color: backrs.colors['Colors/Base/White'],
        },
        '& .MuiSnackbarContent-action': {
            marginRight: backrs.spacing['spacing-none'],
        },
        '& .MuiSnackbarContent-message': __assign({}, typography['text-sm-medium']),
    });
};
